import { Box } from '@jfs/ui-new'
import { FC } from 'react'
import { ProgressTypes } from '../../util/util'
import { styles } from './styles'

interface ProgressProps {
  hide?: boolean
  type: ProgressTypes
}

const Progress: FC<ProgressProps> = ({ hide = false, type }: ProgressProps) => {
  if (hide) {
    return null
  }
  const prog1 = { ...styles[type].progress, ...styles[type].progFirst }
  const prog2 = { ...styles[type].progress, ...styles[type].progMiddle }
  const prog3 = { ...styles[type].progress, ...styles[type].progThird }

  return (
    <Box {...styles[type].progressStyle}>
      <Box {...prog1} />
      <Box {...prog2} />
      <Box {...prog3} />
    </Box>
  )
}
export { Progress }
